import { AddFloatingViewerIconButton } from "../utils/AddFloatingViewerIconButton";
import { BuildFontString } from "../utils/BuildFontString";
import { Div2Floor } from "../utils/Div2Floor";
import { enumFontIconWeights, enumKeyboardTargetEnterAction, kExitCircleChar } from "../constants";
import { QFAButton } from "./QFAButton";
import { QTextEditBase } from "./QTextEditBase";
import { Globals } from "./Globals";
import { fontIconString } from "../utils/fontIconString.js";
import { MeasureTextHeight } from "../utils/MeasureTextHeight.js";

export class QTextEdit extends QTextEditBase {
  constructor() {
    super();
    this.fLabel = null;
    this.fEditMode = false;

    this.fAlignment = "left";
    this.fFontName = "Verdana";
    this.fFontSize = 11;
    this.fFontColor = "#000000";
    this.fBold = false;
    this.fItalic = false;
    //this.fVAlignment = 'middle';

    this.fTabID = -1;
  }

  InitTextEdit() {
    this.SetEnabled(true);
    this.SetIsControl(true);
    this.SetIsSelectable(false);

    this.SetWantsKeyboardInput(true);
    this.InitTextEditBase();

    this.SetFillColor("#FFFFFF");
    this.SetDblClickCmd("TESelectAll");
  }

  DoCloseElement() {
    this.ExitKeyboardTarget(null, null);
  }

  //=================================================================================================
  // Get/Set Methods for presentation
  TEGetAlignment(includeJustify) {
    return this.fAlignment;
  }

  TESetAlignment(alignment) {
    this.fAlignment = alignment;
  }

  TEGetVAlignment() {
    return this.fVAlignment;
  }

  TESetVAlignment(vAlignment) {
    this.fVAlignment = vAlignment;
  }

  SetFontName(fontName) {
    this.fFontName = fontName;
  }

  GetFontName() {
    return this.fFontName;
  }

  SetFontSize(fontSize) {
    this.fFontSize = fontSize;
  }

  GetFontSize() {
    return this.fFontSize;
  }

  SetFontColor(fontColor) {
    this.fFontColor = fontColor;
  }

  GetFontColor(fontColor) {
    return this.fFontColor;
  }

  SetFontBold(fontBold) {
    this.fBold = fontBold;
  }

  GetFontBold() {
    return this.fBold;
  }

  SetFontItalic(fontItalic) {
    this.fItalic = fontItalic;
  }

  GetFontItalic(fontItalic) {
    return this.fItalic;
  }

  //=================================================================================================
  // Tab Handling
  SetTabID(tabID) {
    this.fTabID = tabID;
  }

  GetTabID() {
    return this.fTabID;
  }

  //=================================================================================================
  // Utility methods
  TEGetFontString() {
    // Override from base class
    return BuildFontString(this.fFontName, this.fFontSize, this.fBold, this.fItalic);
  }

  AddClearButton() {
    var clearTEButton = AddFloatingViewerIconButton(
      this,
      kExitCircleChar,
      "ClearTextEdit",
      0,
      this.fVertOffset,
      null,
      Globals._themeMode.text.alt,
      fontIconString(16, enumFontIconWeights.regular)
    );
    clearTEButton.SetPositionX(this.GetPositionX() + this.GetWidth() - clearTEButton.GetWidth());
    clearTEButton.SetPositionY(
      this.GetPositionY() + Div2Floor(this.GetHeight() - clearTEButton.GetHeight())
    );
    clearTEButton["textedit"] = this;
    this.fClearButton = clearTEButton;

    this.UpdateClearButton();
    return clearTEButton;
  }

  UpdateClearButton() {
    var clearButton = this.fClearButton;
    if (!clearButton) return;
    var enableIt = this.GetEditContent().length > 0;
    clearButton.SetShownState(enableIt);
    clearButton.SetEnabled(enableIt);
  }

  //=================================================================================================
  // Mode handling
  InEditMode() {
    return this.fEditMode;
  }

  DoEnterKeyboardTarget(enterAction) {
    if (!this.InEditMode()) {
      this.fEditMode = true;
      if (this.fLastCursorTime === -1)
        this.fCursorTimer = setInterval(function () {
          Globals._wsMgr.RenderWSHandler();
        }, 200);
      switch (enterAction) {
        case enumKeyboardTargetEnterAction.selectAll:
          this.SelectAll();
          break;
        case enumKeyboardTargetEnterAction.insertAtEnd:
          this.SetInsertAtEnd();
          break;
      }
      this.TEStartEdit();
      //ota_focus(true,this);
    }
    this.UpdateClearButton();
    return this.fEditMode;
  }

  DoExitKeyboardTarget(targetPanel, previousPanel) {
    if (this.InEditMode()) {
      this.fEditMode = false;
      if (this.fCursorTimer) clearInterval(this.fCursorTimer);
      this.fLastCursorTime = -1;
      this.TEFinishEdit();
      this.CommitEditContent(this.GetEditContent());
    }
  }

  CommitEditContent(newContent) {
    return false;
  }

  SetFontIcon(fontIcon) {
    this.fFontIcon = fontIcon;
  }

  SetFontIconStyle(fontIconStyle) {
    this.fFontIconStyle = fontIconStyle;
  }

  GetFontIconStyle() {
    if (this.fFontIconStyle == null) {
      var fontIconSize = this.fFontSize ? this.fFontSize : 14;
      var fontIconWeight = this.fBold ? enumFontIconWeights.bold : enumFontIconWeights.regular;
      this.fFontIconStyle = fontIconString(fontIconSize, fontIconWeight);
    }
    return this.fFontIconStyle;
  }

  GetFontIconLabelWidth() {
    if (this.fFontIconWidth == null) {
      this.fFontIconWidth =
        MeasureTextHeight(this.GetFontIconStyle(), this.fFontSize, this.fFontIcon) +
        this.fIconBuffer;
    }
    return this.fFontIconWidth;
  }

  //============= search bar text edits ( see qpanel method 'addsearchbar' for proper usage )
  SetSearchStr(searchStrObj) {
    var authSearchKey = searchStrObj.GetSearchStr(this);
    if (authSearchKey && authSearchKey.length > 0) this.SetEditContent(authSearchKey);
  }

  SetSyncKey(syncKey) {
    this.fSyncKey = syncKey;
  }

  GetSyncKey() {
    return this.fSyncKey || "";
  }

  SetSearchStrInfo(sectionID) {
    this.fSectionID = sectionID;
  }

  GetElementState() {
    return {
      id: this.GetTabID(),
      start: this.fInsertionStart,
      end: this.fInsertionEnd,
      control: this.fControlInsertionStart,
      action: enumKeyboardTargetEnterAction.noAction
    };
  }

  SetPostUpdateFunction(thisArg, functionDef) {
    this.fPostUpdateTE = functionDef.bind(thisArg, this);
  }

  SetIgnorePanelUpdate(ignorePanelUpdate) {
    this.fIgnorePanelUpdate = ignorePanelUpdate;
  }

  GetIgnorePanelUpdate() {
    return this.fIgnorePanelUpdate;
  }

  //=================================================================================================
  // Keyboard handling methods
  EnterEditMode(x, y) {
    return true;
  }

  ElementHandleKeyboard(keyInfo) {
    //	var charCode = event.charCode;
    //	var modKeys = EventToModKeys(event);
    var ctrlKey = keyInfo.ctrlKey;

    //if (charCode == 0)
    //	return false;

    var inEditMode = this.InEditMode();
    if (inEditMode) {
      //if (ctrlKey)		// Eat the ctrlKey if already editing
      //	return true;
    } else {
      //if (ctrlKey)		// Bubble the ctrlKey Up to the next level
      //	return false;
      inEditMode = this.EnterEditMode();
    }

    var handled = false;
    if (inEditMode) handled = this.TEHandleKeyboard(keyInfo); // event,keySource);

    return handled;
  }

  //=================================================================================================
  // Debugging
  ObjectName() {
    return "QTextEdit";
  }

  //=================================================================================================
  // Tablet/iPhone/iPad
  WantsOnscreenKeypad() {
    return true;
  }

  //===================================================================
  AddMoreTextButton() {
    var x = this.fHorzOffset + this.fWidth - 18;
    var y = this.fVertOffset - 10;
    var fs = '600 9px "Font Awesome 5 Pro"';
    var moreTextButton = new QFAButton();
    moreTextButton.InitButton(this, "\uf08e", "EnterMoreText", x, y, 24, 24, fs);
    moreTextButton["textedit"] = this;
    this.fExpanderButton = moreTextButton;
    this.fRightIndent = 15;
  }

  DoSetEnabled(enabled) {
    if (this.fExpanderButton) {
      this.fExpanderButton.SetEnabled(enabled);
    }
  }
}
